import "./edit-card-series.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormCardSeries from "../form-card-series/form-card-series";
import { useEditCardSeries } from "./edit-card-series.hook";
import FormCardSeriesActivate from "../form-card-series-activate/form-card-series-activate";

export function EditCardSeries() {
  const {
    cardSeriesData,
    isLoading,
    cardSeriesError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditCardSeries();

  const title = <h1>Edit Card Series</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormCardSeriesActivate />
      </section>
    </div>
  );

  return (
    <div id="EditCardSeries" className="card-series">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {cardSeriesError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditCardSeries;
